export default function dialog({ variables }) {
    return {
        MuiDialog: {
            defaultProps: {
                fullWidth: true,
                maxWidth: "sm",
                BackdropProps: {
                    sx: {
                        backgroundColor: variables.popper_background,
                    },
                },
            },
            styleOverrides: {
                paper: {
                    border: `1px solid ${variables.border_subtle}`,
                    borderRadius: variables.border_radius_large,
                },
                paperWidthXs: {
                    maxWidth: `min(${variables.dialog_width_xs}, calc(100% - 64px))`,
                    maxHeight: "48vh",
                },
                paperWidthSm: {
                    maxWidth: `min(${variables.dialog_width_sm}, calc(100% - 64px))`,
                    maxHeight: "72vh",
                },
                paperWidthMd: {
                    maxWidth: `min(${variables.dialog_width_md}, calc(100% - 64px))`,
                    maxHeight: "84vh",
                },
                paperWidthLg: {
                    maxWidth: `min(${variables.dialog_width_lg}, calc(100% - 64px))`,
                    maxHeight: "96vh",
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    overflow: "hidden",
                    padding: `${variables.spacing_03} ${variables.spacing_05}`,
                    borderBottom: `1px solid ${variables.border_subtle}`,
                    backgroundColor: variables.surface_band,
                    color: variables.text_primary,
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    overflowY: "auto",
                    overflowX: "hidden",
                    padding: variables.spacing_05,
                    ".MuiDialogTitle-root + &": {
                        paddingTop: variables.spacing_05,
                    },
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: `${variables.spacing_03} ${variables.spacing_05}`,
                    borderTop: `1px solid ${variables.border_subtle}`,
                },
                spacing: {
                    "& > :not(:first-of-type)": {
                        marginLeft: variables.spacing_05,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=dialog.js.map